import { render, staticRenderFns } from "./AssetStatusInput.vue?vue&type=template&id=f9def2ea"
import script from "./AssetStatusInput.vue?vue&type=script&lang=ts"
export * from "./AssetStatusInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports